import {
  SR_CONTRACT_START,
  SR_CONTRACT_END,
  SR_CONTRACT_BY_ID,
  SR_TYPE_CONFIG_DATA,
  SR_TYPE_CONFIG_DATA_ID,
  SR_CALC_RESULTS_SUCCESS,
  SR_CALC_ANALYSIS_RESULTS_SUCCESS,
  SR_POSTED_LOADING_START,
  SR_POSTED_LOADING_END,
  SR_POSTED_RESULTS_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { history } from '../../../components/Helpers';
import { getRebateRoutePrefix } from '../../../components/Helpers/rebateRoute';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

const SRTypes = (type, data) => ({ type, data });

// ─── Contract CRUD ────────────────────────────────────────────────────────────

export const getSupplierRebateContract = (id, isPendingContract) => {
  return (dispatch) => {
    dispatch(SRTypes(SR_CONTRACT_START));
    getSupplierRebateContractAPI(id, isPendingContract)
      .then((response) => {
        dispatch(SRTypes(SR_CONTRACT_BY_ID, response.data.response));
        dispatch(SRTypes(SR_CONTRACT_END));
      })
      .catch(() => dispatch(SRTypes(SR_CONTRACT_END)));
  };
};

const getSupplierRebateContractAPI = (id, isPendingContract) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  const BASE_API = '/supplier-rebate/contract';
  const url = isPendingContract ? `${BASE_API}/${id}?is_pending_contract=true` : `${BASE_API}/${id}`;
  return axios.get(url, { headers });
};

export const submitSupplierRebateContract = (type, id, data) => {
  return async (dispatch, getState) => {
    dispatch(SRTypes(SR_CONTRACT_START));
    try {
      const response = await submitSupplierRebateContractAPI(type, id, data);
      dispatch(SRTypes(SR_CONTRACT_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(SRTypes(SR_CONTRACT_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError };
      }
      throw error;
    }
  };
};

const submitSupplierRebateContractAPI = (type, id, data) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (type === 'edit') return axios.put('/supplier-rebate/contract', data, { headers });
  return axios.post('/supplier-rebate/contract', data, { headers });
};

export const deleteSupplierRebateContract = (id) => {
  return async (dispatch) => {
    dispatch(SRTypes(SR_CONTRACT_START));
    try {
      const response = await deleteSupplierRebateContractAPI(id);
      dispatch(SRTypes(SR_CONTRACT_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || 'Deleted successfully');
        return { success: true, response };
      }
    } catch (error) {
      dispatch(SRTypes(SR_CONTRACT_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) await handleExecutionLog(dispatch, logNumber);
      throw error;
    }
  };
};

const deleteSupplierRebateContractAPI = (id) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.delete(`/supplier-rebate/contract/${id}`, { headers });
};

// ─── Type Config ──────────────────────────────────────────────────────────────

export const getSupplierRebateTypeConfig = (id, param) => {
  return (dispatch) => {
    dispatch(SRTypes(SR_CONTRACT_START));
    getSupplierRebateTypeConfigAPI(id, param)
      .then((response) => {
        if (id || param)
          dispatch(SRTypes(SR_TYPE_CONFIG_DATA_ID, response.data.response));
        else
          dispatch(SRTypes(SR_TYPE_CONFIG_DATA, response.data.response));
        dispatch(SRTypes(SR_CONTRACT_END));
      })
      .catch(() => dispatch(SRTypes(SR_CONTRACT_END)));
  };
};

const getSupplierRebateTypeConfigAPI = (id, param) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (id) return axios.get(`/config/compliance-type/${id}`, { headers });
  if (param) return axios.get('/config/compliance-type', { headers, params: param });
  return axios.get('/config/compliance-type', { headers });
};

// ─── Calculation Results ──────────────────────────────────────────────────────

export const supplierRebateCalculationResults = (data, apipath) => {
  return async (dispatch) => {
    dispatch(SRTypes(SR_CONTRACT_START));
    try {
      const response = await supplierRebateCalculationResultsAPI(data, apipath);
      dispatch(SRTypes(SR_CONTRACT_END));
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (response.data.result && response.data.result.length > 0) {
          dispatch(SRTypes(SR_CALC_RESULTS_SUCCESS, response.data));
          history.push(`/${getRebateRoutePrefix()}-calculation-simulation-results`);
        }
        return { success: !hasError, response };
      } else {
        if (response.data.result && response.data.result.length > 0) {
          dispatch(SRTypes(SR_CALC_RESULTS_SUCCESS, response.data));
          history.push(`/${getRebateRoutePrefix()}-calculation-simulation-results`);
        } else {
          globalToast.showWarning('No records found.');
        }
        return { success: true, response };
      }
    } catch (error) {
      dispatch(SRTypes(SR_CONTRACT_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};

const supplierRebateCalculationResultsAPI = (data, apipath) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.post(apipath, data, { headers });
};

// ─── Calculation Analysis Results ────────────────────────────────────────────

export const supplierRebateCalculationAnalysisResults = (data, apipath, moduleType) => {
  return async (dispatch) => {
    dispatch(SRTypes(SR_CONTRACT_START));
    try {
      const response = await supplierRebateCalculationAnalysisResultsAPI(data, apipath);
      dispatch(SRTypes(SR_CONTRACT_END));
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (response.data.result && response.data.result.length > 0) {
          dispatch(SRTypes(SR_CALC_ANALYSIS_RESULTS_SUCCESS, response.data));
          history.push(`/${getRebateRoutePrefix()}-calculation-analysis-result`);
        }
        return { success: !hasError, response };
      } else {
        if (response.data.response && response.data.response.length > 0) {
          dispatch(SRTypes(SR_CALC_ANALYSIS_RESULTS_SUCCESS, response.data.response));
          history.push(`/${getRebateRoutePrefix()}-calculation-analysis-result`);
        } else {
          globalToast.showWarning('No records found.');
        }
        return { success: true, response };
      }
    } catch (error) {
      dispatch(SRTypes(SR_CONTRACT_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};

const supplierRebateCalculationAnalysisResultsAPI = (data, apipath) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.post(apipath, data, { headers });
};

export const supplierRebatePostedResults = (data, apiPath, page) => {
  return async (dispatch) => {
    dispatch(SRTypes(SR_POSTED_LOADING_START));
    try {
      const response = await supplierRebatePostedResultsApi(data, apiPath);
      dispatch(SRTypes(SR_POSTED_LOADING_END));
      const logNumber = response?.data?.log_number;
      const resultData = response?.data?.result || response?.data?.response;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (!hasError && resultData && resultData.length > 0) {
          dispatch(supplierRebatePostedResultsSuccess({ ...response.data, result: resultData }));
          history.push(`/${getRebateRoutePrefix()}-${page}-results`);
        }
        return { success: !hasError, response };
      } else {
        if (resultData && resultData.length > 0) {
          dispatch(supplierRebatePostedResultsSuccess({ ...response.data, result: resultData }));
          history.push(`/${getRebateRoutePrefix()}-${page}-results`);
        } else {
          globalToast.showWarning('No records found.');
        }
        return { success: true, response };
      }
    } catch (error) {
      dispatch(SRTypes(SR_POSTED_LOADING_END));
      const logNumber = error?.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};

const supplierRebatePostedResultsApi = (data, apiPath) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.post(apiPath, data, { headers });
};

export const supplierRebatePostedResultsSuccess = (data) => {
  return {
    type: SR_POSTED_RESULTS_SUCCESS,
    data,
  };
};

// ─── Posting Reversal ─────────────────────────────────────────────────────────

export const supplierRebatePostingReversal = (payload, reversalType) => {
  return async (dispatch) => {
    dispatch(SRTypes(SR_POSTED_LOADING_START));
    const fullPayload = {
      ...payload,
      application_type: 'Supplier Rebate',
      functionality: reversalType === 'accrual' ? 'Accrual' : 'Payment',
    };
    try {
      const response = await supplierRebatePostingReversalApi(fullPayload);
      dispatch(SRTypes(SR_POSTED_LOADING_END));
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      }
      return { success: true, response };
    } catch (error) {
      dispatch(SRTypes(SR_POSTED_LOADING_END));
      const logNumber = error?.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};

const supplierRebatePostingReversalApi = (data) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.post('postings/reversal', data, { headers });
};

// ─── Posted Results Refresh (no navigation) ───────────────────────────────────

export const supplierRebatePostedResultsRefresh = (data, apiPath) => {
  return async (dispatch) => {
    dispatch(SRTypes(SR_POSTED_LOADING_START));
    try {
      const response = await supplierRebatePostedResultsApi(data, apiPath);
      dispatch(SRTypes(SR_POSTED_LOADING_END));
      const logNumber = response?.data?.log_number;
      const resultData = response?.data?.result || response?.data?.response;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (!hasError && resultData?.length > 0) {
          dispatch(supplierRebatePostedResultsSuccess({ ...response.data, result: resultData }));
        }
      } else if (resultData?.length > 0) {
        dispatch(supplierRebatePostedResultsSuccess({ ...response.data, result: resultData }));
      } else {
        globalToast.showWarning('No records found.');
      }
    } catch (error) {
      dispatch(SRTypes(SR_POSTED_LOADING_END));
      const logNumber = error?.response?.data?.log_number;
      if (logNumber) await handleExecutionLog(dispatch, logNumber);
    }
  };
};

/* email*/
export const runPartnerStatementEmail = (data) => {
  return async (dispatch) => {
    dispatch(SRTypes(SR_POSTED_LOADING_START));
    try {
      const response = await runPartnerStatementEmailApi(data);
      dispatch(SRTypes(SR_POSTED_LOADING_END));
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      }
    } catch (error) {
      dispatch(SRTypes(SR_POSTED_LOADING_END));
      const logNumber = error?.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};

const runPartnerStatementEmailApi = (data) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.post('/supplier-rebate/partner-stmt/email', data, { headers });
};
